export default {
  turquoise: '#43BCCD',
  purple: '#672E9B',
  red: '#FF006C',
  orange: '#F86725',
  yellow: '#F9C80D',
};
